import { orderRepository } from '../repositories/order-repository';

async function getOrders() {
    return orderRepository.getAll();
}

export {
    getOrders
};
